import { render } from "./InputSImple.vue?vue&type=template&id=abb2a194"
import script from "./InputSImple.vue?vue&type=script&lang=js"
export * from "./InputSImple.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__